import { TextField, Autocomplete } from '@mui/material';
import { useCaseFieldData, useCaseFieldDispatch } from '../../../hooks/useCaseField';
import type { FieldMode } from '../../../hooks/useCaseField';
import { useGetCalcTypesQuery } from '../../../../../services/ContractService';
import type { CalcTypeView } from '../../../../../services/ContractService/types/dimensionTypes';

interface PayerFieldProps {
  mode: FieldMode;
  company: string;
  centerId: string;
  error?: string;
}

const PayerField: React.FC<PayerFieldProps> = ({ mode, error }) => {
  const data = useCaseFieldData(mode);
  const { dispatchUpdate } = useCaseFieldDispatch(mode);
  const { data: calcTypes = [], isLoading } = useGetCalcTypesQuery();

  const selected = calcTypes.find(ct => ct.value === data.payerId) ?? null;

  return (
    <Autocomplete<CalcTypeView, false, false, false>
      options={calcTypes}
      value={selected}
      loading={isLoading}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onChange={(_, newValue) => {
        dispatchUpdate({
          payerId: newValue?.value || '',
        });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Payer Group" required size="small"
          placeholder={isLoading ? 'Loading...' : 'Select a payer group...'}
          error={!!error} helperText={error}
        />
      )}
    />
  );
};

export default PayerField;